import { getRequest, postRequest, patchRequest } from "../utils/axios";

const projectQuery = (projectHash, extra = {}) => {
  const params = new URLSearchParams({ project: projectHash });
  Object.entries(extra).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      params.set(key, String(value));
    }
  });
  return `?${params.toString()}`;
};

export const mediaService = {
  list: (projectHash, params = {}, onSuccess, onError) => {
    // Back-compat: list(hash, onSuccess, onError)
    if (typeof params === "function") {
      onError = onSuccess;
      onSuccess = params;
      params = {};
    }
    return getRequest(
      `/api/v1/project-media/${projectQuery(projectHash, params)}`,
      onSuccess,
      onError,
    );
  },

  get: (projectHash, hash, onSuccess, onError) =>
    getRequest(
      `/api/v1/project-media/${hash}/${projectQuery(projectHash)}`,
      onSuccess,
      onError,
    ),

  upload: (projectHash, file, { title, description, media_type, onUploadProgress, signal } = {}, onSuccess, onError) => {
    const data = new FormData();
    data.append("file", file);
    if (title) data.append("title", title);
    if (description) data.append("description", description);
    if (media_type) data.append("media_type", media_type);
    const config = {};
    if (onUploadProgress) config.onUploadProgress = onUploadProgress;
    if (signal) config.signal = signal;
    return postRequest(
      `/api/v1/project-media/${projectQuery(projectHash)}`,
      data,
      onSuccess,
      onError,
      config,
    );
  },

  uploadVersion: (projectHash, hash, file, { onUploadProgress, signal } = {}, onSuccess, onError) => {
    const data = new FormData();
    data.append("file", file);
    const config = {};
    if (onUploadProgress) config.onUploadProgress = onUploadProgress;
    if (signal) config.signal = signal;
    return postRequest(
      `/api/v1/project-media/${hash}/versions/${projectQuery(projectHash)}`,
      data,
      onSuccess,
      onError,
      config,
    );
  },

  update: (projectHash, hash, data, onSuccess, onError) =>
    patchRequest(
      `/api/v1/project-media/${hash}/${projectQuery(projectHash)}`,
      data,
      onSuccess,
      onError,
    ),

  bulkDelete: (projectHash, hashes, onSuccess, onError) =>
    postRequest(
      `/api/v1/project-media/bulk-delete/${projectQuery(projectHash)}`,
      { hashes },
      onSuccess,
      onError,
    ),
};
